import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-courses-tab-2-part',
	standalone: true,
	templateUrl: './experience-courses-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./experience-courses-tab-2.part.scss`],
})
export class ExperienceCoursesTab2Part {
}
